export enum INFERENCE_ROUTE_NAMES {
  INFERENCE_NEW = "inference-new",
  INFERENCE_ASSETS_EDIT = "inference-assets-edit",
  INFERENCE_HUGGING_FACE_EDIT = "inference-hugging-face-edit",
  INFERENCE_NIM_EDIT = "inference-nim-edit",
  INFERENCE_FLAT_HYBRID = "inference-hybrid",
  INFERENCE_FLAT_UPDATE = "inference-update",
}
